import axios from 'axios';
import { useState } from 'react';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';

// imageObj should contain:
// "imageId": "string",
// "indexNr": 0,
// "legend": "string",

const useUploadImage = () => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const { mutate, data, isLoading } = useMutation(
    async ({ imageFile }) => {
      let formData = new FormData();
      formData.append('file', imageFile);
      setUploadProgress(0);
      return (
        await axios.post('/images', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          timeout: 6000000, // we don't want timeout while upload is happening
          onUploadProgress, // event for onUploadProgress
        })
      ).data;
    },
    {
      onSuccess: (resData, { imageFile }) => {
        toast.success('Image Uploaded', {
          position: toast.POSITION.TOP_LEFT,
        });
      },
      onError: (err) => {
        let errorMsg = err?.response?.data?.error || err.message;
        toast.error(`${errorMsg}`, {
          position: toast.POSITION.TOP_LEFT,
        });
      },
    }
  );

  const onUploadProgress = (event) => {
    if (event) {
      setUploadProgress(Math.round((100 * event.loaded) / event.total));
    }
  };
  const uploadImage = (imageFile, options) => mutate({ imageFile }, options);

  return {
    uploadImage,
    isLoading,
    uploadProgress,
    imageId: data,
  };
};

export default useUploadImage;
